import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import CleanUpImage from "../../assets/images/cleanup.png";
import { Image } from "@mui/icons-material";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
const ModalConfirm = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  image = null,
  icon = null,
  type = "confirm",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      //   width="956px"
      //   height="504px"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          padding: 2,
          borderRadius: 3,
        },
      }}
    >
      {title && (
        <DialogTitle>
          <Typography variant="h4">{title}</Typography>
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          padding: 2,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          {icon ? (
            icon
          ) : (
            <img
              src={image ?? CleanUpImage}
              alt="Confirm Icon"
              style={{
                width: 200,
                height: 200,
                objectFit: "contain",
              }}
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h5">
              {message ?? "ยืนยันลบรายการนี้หรือไม่"}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                marginTop: 2,
              }}
            >
              {type !== "error" && (
                <GradientButtonOutline
                  onClick={onClose}
                  sx={{
                    borderRadius: 2,
                  }}
                >
                  ยกเลิก
                </GradientButtonOutline>
              )}
              <GradientButton
                onClick={onConfirm}
                sx={{
                  borderRadius: 2,
                  minWidth: 100,
                }}
              >
                ตกลง
              </GradientButton>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalConfirm;
